<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="img-back pull-left" href="javascript:window.history.go(-1)">返回</a>
        <h1>点名</h1>
        <span class="pull-right icon-right icon-setup text-hide" @click="popupVisebleRollcallList = true">发起点名</span>
      </div>
      <div class="liner"></div>
    </div>


    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page" v-infinite-scroll="loadBottom"
    infinite-scroll-disabled="isGetting"
    infinite-scroll-distance="150">

      <div class="rollcall" v-for="item in rollcallList">
        <p class="margin-15">{{getAliasDate(item.time)}}</p>
        <ul class="list-group-item">
          <li class="list-group" v-for="callInfo in item.list">
            <div class="liner"></div>

            <a class="padding-15 clearfix block" @click.prevent="goRollcallDetail(callInfo)" v-if="callInfo.typeId == 0">
              <span class="pull-right text-right">
                <span class="rollinfo succ" v-if="callInfo.callStudentNum == 0">全部已点</span>
                <span class="rollinfo warning" v-else>{{callInfo.callStudentNum}}人未点</span>
              </span>
              <span class="pull-left">
                <span class="block"><span class="font-16">{{callInfo.msg}}</span></span>
                <span class="block gray">{{callInfo.teacherName}}</span>
                <cite class="gray">{{callInfo.callBeginTime}}</cite>
              </span>
            </a>

            <a class="padding-15 clearfix block" @click.prevent="goRollcallDetail(callInfo)" v-if="callInfo.typeId == 1">
              <span class="pull-left">
                <span class="block"><span class="font-16">家长接回</span></span>
                <span class="block gray font-12">记录每天家长到园点接回孩子情况，家长确认接回孩子后所发生的安全责任与园点无关</span>
              </span>
              <span class="pull-right text-right">
                <span class="rollinfo succ" v-if="callInfo.callStudentNum == 0">全部已点</span>
                <span class="rollinfo warning" v-else>{{callInfo.callStudentNum}}人未点</span>
              </span>
            </a>
          </li>

        </ul>
      </div>
    </div>
    </mt-loadmore>

  <mt-popup 
    v-model="popupVisebleRollcallList" 
    position="bottom"
    >
      <div class="roll-setup">
        <span class="block text-center margin-15">选择名单</span>
        <ul class="clearfix padding-15">
          <li class="col-xs-4"><a class="button-pill-circle block" @click.prevent="insertStudentCall(101)">中午接</a></li>
          <li class="col-xs-4"><a class="button-pill-circle block" @click.prevent="insertStudentCall(102)">中午送</a></li>
          <li class="col-xs-4"><a class="button-pill-circle block" @click.prevent="insertStudentCall(103)">傍晚接</a></li>
          <!-- <a class="button-pill-circle" href="javascript:;" v-tap="insertStudentCall(100)">所有人</a> -->
          <li class="col-xs-6"><router-link class="button-pill-circle block" :to="{'path': '/rollcall/custom'}">自定义名单</router-link></li>
          <li class="col-xs-6"><a class="block text-center font-12 gray padding-15" @click.prevent.stop="isHideCreateRollcallHelp = !isHideCreateRollcallHelp">不明白？点这里</a></li>
        </ul>
        <div class="liner"></div>
        <p class="gray margin-15 font-12">点名功能可以多个老师同时协作点名，孩子点名情况及时反馈给关联家长。<br>点名记录只保存一个月，到期自动清空哦！</p>

        <div v-show="!isHideCreateRollcallHelp">
        <div class="liner"></div>
          <p class="padding-15"><strong>中午接、中午送：</strong><br>
  中午接和中午送包含午托，午晚托，中托，零托，长托，全托。<br><br>
  <strong>傍晚接：</strong><br>
  包含晚托，午晚托，中托，傍晚托，零托，全托，长托。<br>
  <br>
  <strong>自定义：</strong><br>
  自己选择要点名的名单
          </p>
        </div>
        <ul class="list-group-item tinny" style="margin:0">
          <li class="list-group">
            <div class="liner"></div>
            <span class="group-txt text-center" @click="popupVisebleRollcallList = false">取消</span>
          </li>
        </ul>
      </div>
      </mt-popup>


  </div>
</template>

<script>
import { service } from '../../service'
export default {
  data () {
    return {
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      isHideCreateRollcall: true, // 隐藏点名选项
      isHideCreateRollcallHelp: true, // 隐藏点名帮助
      isHideDate: true,
      get_call_list_para: service.setPara('getCallList'),
      insert_student_call_para: service.setPara('insertStudentCall'),
      rollcallList: [],
      curcheId: 0,
      teacherId: 0,
      nowDate: new Date().format('yyyy-MM-dd'),
      yesterdayDate: '',
      isGetting: true, // 是否正在获取数据中
      isOver: false, // 是否是没有数据获取了
      begin_year: '',
      begin_month: '',
      begin_day: '',
      end_year: '',
      end_month: '',
      end_day: '',
      popupVisebleRollcallList: false
    }
  },
  mounted: function () {
    // 格式化昨天格式
    var yesterdayTemp = new Date()
    var date = yesterdayTemp.getDate() - 1
    yesterdayTemp.setDate(date)
    this.yesterdayDate = yesterdayTemp.format('yyyy-MM-dd')

    this.curcheId = this.cookie_login_data.curcheId
    this.teacherId = this.cookie_login_data.teacherId
    this.get_call_list_para.curcheId = this.curcheId
    this.get_call_list_para.endTime = new Date().format('yyyy-MM-dd')
    this.getCallList()
    // this.isScrollBottom()
  },
  methods: {
    loadTop (id) {
      this.get_call_list_para.endTime = new Date().format('yyyy-MM-dd')
      this.rollcallList = []
      this.isOver = false
      this.getCallList()
      this.$refs.loadmore.onTopLoaded(id)
    },
    loadBottom () {
      if (this.isOver || this.isGetting) {
        return
      }
      let dateTemp = new Date(this.rollcallList[this.rollcallList.length - 1].time)
      let date = dateTemp.getDate() - 1
      dateTemp.setDate(date)
      this.get_call_list_para.endTime = dateTemp.format('yyyy-MM-dd')
      this.getCallList()
    },
    // isScrollBottom: function () {
    //   var that = this
    //   $(window).bind('scroll', function () {
    //     // 然后判断窗口的滚动条是否接近页面底部，这里的20可以自定义
    //     if ($(document).scrollTop() + $(window).height() > $(document).height() - 120 && !that.isGetting && !that.isOver) {
    //       var dateTemp = new Date(that.rollcallList[that.rollcallList.length - 1].time)
    //       var date = dateTemp.getDate() - 1
    //       dateTemp.setDate(date)
    //       that.get_call_list_para.endTime = dateTemp.format('yyyy-MM-dd')
    //       that.getCallList()
    //     }
    //   })
    // },
    createRollcall: function () {
      this.isHideCreateRollcall = false
    },
    getCallList: function (para) {
      this.isGetting = true

      let that = this
      let obj = {context: this, para: this.get_call_list_para, successFun: (response) => {
        that.isGetting = false
        if (response.data.length == 0) {
          that.isOver = true
        } else {
          that.rollcallList = that.rollcallList.concat(response.data)
        }
      }}
      service.request(obj)
    },
    getAliasDate: function (date) { // 获取时间别名
      if (date == this.nowDate) {
        return '今天'
      } else if (date == this.yesterdayDate) {
        return '昨天'
      } else {
        return date
      }
    },
    insertStudentCall: function (typeId) {
      this.insert_student_call_para.teacherId = this.teacherId
      this.insert_student_call_para.curcheId = this.curcheId
      this.insert_student_call_para.typeId = typeId

      let obj = {context: this, para: this.insert_student_call_para, successFun: (response) => {
        this.$router.push('/rollcall/detail/' + response.data)
      }}
      service.request(obj)
    },
    selectByDate: function () {
      var beginTime = ''
      if (this.begin_year && this.begin_month && this.begin_day) {
        var tempBeginTime = new Date()
        try {
          tempBeginTime.setDate(this.begin_year)
          tempBeginTime.setMonth(this.begin_month - 1)
          tempBeginTime.setFullYear(this.begin_day)
          beginTime = tempBeginTime.format('yyyyMMdd')
        } catch (e) {
          this.beginTime = ''
        }
      }
      var endTime = ''
      if (this.end_year && this.end_month && this.end_day) {
        var tempEndTime = new Date()
        try {
          tempEndTime.setDate(this.end_year)
          tempEndTime.setMonth(this.end_month - 1)
          tempEndTime.setFullYear(this.end_day)
          endTime = tempEndTime.format('yyyyMMdd')
        } catch (e) {
          this.endTime = ''
        }
      }
      this.get_call_list_para.beginTime = beginTime
      this.get_call_list_para.endTime = endTime
      this.getCallList()
    },
    goRollcallDetail: function (callInfo) {
      if (callInfo.state == 4) {
        return
      } else {
        if (callInfo.typeId == 0) {
          this.$router.push('/rollcall/detail/' + callInfo.callId)
        } else {
          this.$router.push('/rollcall/hand/' + callInfo.callId)
        }
      }
    }
  }
}
</script>
<style scoped>
  .mint-popup-bottom{width:100vw;}
</style>



// WEBPACK FOOTER //
// rollcallList.vue?48ed2264